import { apiSlice } from './apiSlice';

export const invoiceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Generate or fetch an invoice for a LOGGED-IN user’s order
    generateInvoice: builder.mutation({
      query: ({ orderId, force } = {}) => ({
        url: `/api/invoices/${orderId}/generate`,
        method: 'POST',
        // ?force=1 triggers regeneration on the server (optional)
        params: force ? { force: 1 } : undefined,
      }),
    }),

    // Generate or fetch an invoice for a GUEST order
    generateGuestInvoice: builder.mutation({
      query: ({ orderId, force } = {}) => ({
        url: `/api/invoices/guest/${orderId}/generate`,
        method: 'POST',
        params: force ? { force: 1 } : undefined,
      }),
    }),
  }),
  // set to true only if you expect to redefine these endpoints elsewhere
  // overrideExisting: false,
});

export const {
  useGenerateInvoiceMutation,
  useGenerateGuestInvoiceMutation,
} = invoiceApiSlice;
